import { Api } from '../Common/rest-api/api-exports';
import * as _ from 'ramda';

export const getUserStatus = () =>
    Api.Users.details()
        .then(res => res.body.role)
        .catch(() => 'invalid user status.');

export const getCurrentUser = () =>
    Api.Users.details()
        .then(res => res.body)
        .catch(() => 'invalid user status.');

export const getCompanyOfUser = () => {
    return Api.Users.details()
        .then(res => {
            return [{ id: res.body.company.id, name: res.body.company.name }];
        })
        .catch(() => []);
};

export const getPharmacyOfUser = () =>
    Api.Users.details()
        .then(res => {
            return [{ id: res.body.pharmacy.id, name: res.body.pharmacy.name }];
        })
        .catch(() => []);

export const getListOfUsers = (data = {}) =>
    Api.Users.list(data)
        .then(res => res.body)
        .catch(error => error);

export const getSingleUser = id =>
    Api.Users.single(id)
        .then(res => res.body)
        .catch(err => err);

export const createUser = details =>
    Api.Users.add({
        names: details.username,
        phone: details.phone,
        email: details.email,
        pharmacy: details.pharmacy,
        company: details.company,
        roles: [details.role]
    });

export const editUser = (id, details) =>
    Api.Users.edit(id, {
        names: details.username,
        phone: details.phone,
        email: details.email,
        pharmacy: details.pharmacy,
        company: details.company,
        roles: [details.role]
    });

export const editUserDetails = (id, details) =>
    Api.Users.edit(id, {
        names: details.username,
        phone: details.phone,
        email: details.email
    });

export const editUserDetailsPassword = details =>
    Api.Passwords.change({
        currentPassword: details.currentPassword,
        password: details.newPassword,
        confirmPassword: details.repeatNewPassword
    });

export const getFreeUsersForCompanyOwner = (identifier, companyId) =>
    Api.Users.freeOwners(identifier, { companyId: companyId })
        .then(res => {
            if (res.body.length !== 0) {
                const companyOwners = res.body.map(owner => {
                    return _.omit(['email', 'phone', 'role'], owner);
                });
                const companyOwnersCount = companyOwners.length;
                return _.mergeAll([{ companyOwners: companyOwners }, { count: companyOwnersCount }]);
            } else {
                return _.mergeAll([{ companyOwners: [] }, { count: 0 }]);
            }
        })
        .catch(err => err);

export const getFreeUsersForPharmacyManager = (identifier, companyId, pharmacyId) =>
    Api.Users.freeManagers(identifier, companyId, { pharmacyId: pharmacyId })
        .then(res => {
            if (res.body.length !== 0) {
                const pharmacyManagers = res.body.map(owner => {
                    return _.omit(['email', 'phone', 'role'], owner);
                });
                const pharmacyManagersCount = pharmacyManagers.length;
                return _.mergeAll([{ pharmacyManages: pharmacyManagers }, { count: pharmacyManagersCount }]);
            } else {
                return _.mergeAll([{ pharmacyManages: [] }, { count: 0 }]);
            }
        })
        .catch(err => err);



// WEBPACK FOOTER //
// ./src/customModules/Users/epics-users.js